import React from 'react'
import { motion } from 'motion/react'
import useNavigation, { JourneyStep } from 'src/lib/hooks/useNavigation'
import { JourneyNavigationComponent } from '../../components/navigation/SecondaryNavBars/common/NavigationWrapper'

const SecondaryNavigationBar = () => {
  const {
    getters: { sidebarOpen, journeyStep }
  } = useNavigation()

  return (
    <motion.nav
      layout
      className='h-fit rounded-xl shrink-0 border-black/6 border-1 bg-gray-100 '
      style={{
        width: !sidebarOpen ? '245px' : 'fit-content'
      }}
      key={journeyStep}
      id='secondary-navigation-bar'
    >
      <JourneyNavigationComponent stepId={journeyStep} />
    </motion.nav>
  )
}

export default SecondaryNavigationBar
